import React, { useState } from "react";
import ReactDOM from "react-dom";
import styles from '../HubManagement.module.css';
import managementStyles from '../../ManagementPages.module.css';
import { Form, Button, FloatingLabel } from "react-bootstrap";

const AssignHubToPatientPopup = ({ hub, patients = [], onClose, onAssign }) => {

    const [patientId, setPatientId] = useState("");
    const buttonDisabled = patientId === "";

    return ReactDOM.createPortal(
        <div className="overlay">
            <div className={styles.PopupContainer}>
                <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <span className={styles.HubsLabel}>Assign Hub</span>
                    
                </div>
                <span className={styles.HubBody2}>
                    {`Assign hub ${hub?.serialNumber || ''} to a patient`}
                </span>
                <Form style={{ width: "300px" }}>
                    <Form.Group className="mb-3">
                        <FloatingLabel controlId="floatingSelect" label="Patient">
                            <Form.Select
                                className={`${managementStyles.BorderedComponent}`}
                                value={patientId}
                                onChange={(e) => setPatientId(e.target.value)}
                                style={{ width: "300px" }}
                            >
                                <option value="">Select Patient</option>
                                {patients.map((patient) => (
                                    <option key={patient.id} value={patient.id}>{patient.name}</option>
                                ))}
                            </Form.Select>
                        </FloatingLabel>
                    </Form.Group>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <Button className={managementStyles.CancelButton} onClick={onClose}>
                            Cancel
                        </Button>
                        <Button
                            disabled={buttonDisabled}
                            onClick={() => onAssign(patientId)}
                            className={managementStyles.CreateButton}
                        >
                            Assign
                        </Button>
                    </div>
                </Form>
            </div>
        </div>,
        document.body
    );
};

export default AssignHubToPatientPopup;
